<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<contest-offer-evaluations-filters
			v-model="dataTable.search"
			:evaluation-type="'agency'"
		/>
		<v-data-table
			:headers="dataTable.headers"
			:rows-per-page-items="[10,20,25]"
			:loading="loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination"
			class="elevation-1">
			<template slot="items" slot-scope="props">
				<td>{{props.item.offerCode}}</td>
				<td>{{props.item.offerTitle}}</td>
				<td>{{props.item.contestName}}</td>
				<td>{{props.item.status}}
					<span class="ml-1" v-if="props.item.status === 'Do poprawek'">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-icon size="18" color="blue" dark v-on="on">mail_outline</v-icon>
							</template>
							<div>
								<div>
									<b>{{ props.item.correctionCause }}</b>
								</div>
								{{ props.item.detailedCorrectionCause }}
							</div>
						</v-tooltip>
					</span>
					<span class="ml-1" v-else-if="props.item.status === 'Zakończona'">
						<span v-if="props.item.recommending === true" style="color: green">(Pozytywna)</span>
						<span v-else style="color: red">(Negatywna)</span>
					</span>
				</td>
				<td>
					<v-icon
						@click="startEvaluation(props.item)"
						v-if="props.item.status === 'Nierozpoczęta'"
						title="Rozpocznij"
					>add_box
					</v-icon>
					<v-icon
						@click="editEvaluation(props.item)"
						v-if="props.item.status === 'Rozpoczęta' || props.item.status === 'Do poprawek'"
						title="Edytuj"
					>edit
					</v-icon>
					<v-icon
						@click="viewEvaluation(props.item)"
						v-if="props.item.status === 'Zakończona'"
						title="Szczegóły"
					>description
					</v-icon>
					<v-icon
						@click="sendInappropriateAssignmentNotification(props.item)"
						v-if="props.item.status === 'Nierozpoczęta' || props.item.status === 'Rozpoczęta' || props.item.status === 'Do poprawek'"
						title="Zgłoś błąd"
					>error
					</v-icon>
				</td>
			</template>
		</v-data-table>
		<inappropriate-assignment-notification-confirmation
			v-if="inappropriateAssignmentDialog"
			v-bind:evaluation="evaluation"
			v-bind:evaluation-type="'AGENCY_EVALUATION'"
			v-on:close-dialog="closeDialog()"
			v-on:sent-inappropriate-assignment="inappropriateAssignment()"/>
	</div>
</template>

<script>
	import {Api} from "@/api";
	import {AgencyEvaluation} from "@/api/generated/AgencyEvaluation";
	import InappropriateAssignmentNotificationConfirmation from "../../InappropriateAssignmentNotificationConfirmation";
	import ContestOfferEvaluationsFilters from "../../../offer/ContestOfferEvaluationsFilters";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "AgencyEvaluationTable",

		components: {ContestOfferEvaluationsFilters, InappropriateAssignmentNotificationConfirmation},

    mixins: [Filters],

		data () {
			return {
				dataTable: {
					search: "",
					headers: [
						{text: "Numer oferty", value: "offerCode", sortable: true},
						{text: "Nazwa oferty", value: "offer", sortable: true},
						{text: "Konkurs", value: "contest", sortable: true},
						{text: "Status", value: "status", sortable: true},
						{text: "Akcje", sortable: false},
					],
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
						sortBy: null
					},
				},
				loading: false,
				inappropriateAssignmentDialog: false,
				evaluation: {}
			};
		},

		mounted () {
			this.removeEmptyTableLoading();
      this.dataTable.pagination = this.retrievePagination(this.dataTable.pagination);
		},


		methods: {
			inappropriateAssignment() {
				this.closeDialog();
				this.evaluation.status = "Niewłaściwie przypisana";
			},

			closeDialog () {
				this.inappropriateAssignmentDialog = false;
			},

			getItemList () {
				let sort = this.buildSort();
				Api.get(this, "/agency-evaluation/list?search=" + this.dataTable.search
					+ "&page=" + this.dataTable.pagination.page
					+ "&result=" + this.dataTable.pagination.rowsPerPage
					+ "&sort=".concat(sort), response => {
					this.dataTable.itemList = response.itemList;
					this.dataTable.itemCount = response.itemCount;
				});
			},

			buildSort() {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			startEvaluation (item) {
				AgencyEvaluation.put(this, item.id, () => {
					this.$router.push("/app/contest/".concat(item.contestId).concat("/agency-evaluation/").concat(item.id));
				});
			},

			editEvaluation (item) {
				this.$router.push("/app/contest/".concat(item.contestId).concat("/agency-evaluation/").concat(item.id));
			},

			viewEvaluation (item) {
				this.$router.push("/app/contest/".concat(item.contestId).concat("/agency-evaluation/").concat(item.id));
			},

			sendInappropriateAssignmentNotification (item) {
				this.evaluation = item;
				this.inappropriateAssignmentDialog = true;
			},

			removeEmptyTableLoading () {
				var el = document.querySelector(".v-datatable__progress");
				el.parentNode.removeChild(el);
			},
		},

		watch: {
			"dataTable.search": {
				handler() {
					this.getItemList();
				},
			},

			"dataTable.pagination": {
				handler(pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			}
		},
	};
</script>

<style scoped>

</style>
